import { createApi } from '@reduxjs/toolkit/query/react';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

import {
  CmsStandardRequirementItem,
  CmsStandardRequirementResponse,
  CmsStandardRequirementsResponse,
  GetCmsStandardRequirementInput,
  GetCmsStandardRequirementsInput,
} from './cmsStandardRequirements.types';

const cmsStandardRequirementsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/cms/standards',
  }),
  reducerPath: 'cmsStandardRequirements',
  tagTypes: ['CmsStandardRequirements'],
  endpoints: (build) => ({
    getStandardRequirements: build.query<
      CmsStandardRequirementItem[],
      GetCmsStandardRequirementsInput
    >({
      query: ({ slug }) => ({
        url: `/${slug}/standard-requirements`,
        method: 'GET',
      }),
      transformResponse: (response: CmsStandardRequirementsResponse) =>
        response.standardRequirements,
      async onQueryStarted({ slug }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          for (const standardRequirement of data) {
            dispatch(
              cmsStandardRequirementsApi.util.upsertQueryData(
                'getStandardRequirement',
                {
                  slug,
                  standardRequirementSlug: standardRequirement.slug,
                },
                standardRequirement,
              ),
            );
          }
        } catch {
          // Ignore cache warmup when list query fails.
        }
      },
    }),
    getStandardRequirement: build.query<
      CmsStandardRequirementItem,
      GetCmsStandardRequirementInput
    >({
      query: ({ slug, standardRequirementSlug }) => ({
        url: `/${slug}/standard-requirements/${standardRequirementSlug}`,
        method: 'GET',
      }),
      transformResponse: (response: CmsStandardRequirementResponse) => {
        return response.standardRequirement;
      },
    }),
  }),
});

export default cmsStandardRequirementsApi;
